exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.thead-dark th[data-v-5945efbc] {\n\tvertical-align: text-top;\n}\n", ""]);

// exports
